export default __webpack_public_path__ + "static/media/NZDS.8a84bd2f.png";